module.exports = __webpack_public_path__ + "4476d3d2.png";